// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__hq0g2","headerWrapper":"style_headerWrapper__8fkDi","title":"style_title__0F0dt","img":"style_img__ZdIgE"};